export default {
  description:
    "Neue Goods is a clothing label from Sydney, Australia creating high quality goods for designers, creatives and anyone with their eye on the internet.",
  url: "https://www.neuegoods.com",
  title: "Neue Goods",
};
